import React from 'react';
import SuperPhilosophyTagline from '../components/SuperPhilosophyTagline';
import { useNavigate } from 'react-router-dom';

const HeroPage = () => {
  const navigate = useNavigate();

  const FHOLogo = ({ size = 120 }) => (
    <svg width={size} height={size} viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={`blueGrad-${size}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{stopColor:'#6BB6FF', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#2E7BC6', stopOpacity:1}} />
        </linearGradient>
        <linearGradient id={`redGrad-${size}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{stopColor:'#FF6B58', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#D93025', stopOpacity:1}} />
        </linearGradient>
        <linearGradient id={`greenGrad-${size}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{stopColor:'#5FD88F', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#2EAB5F', stopOpacity:1}} />
        </linearGradient>
      </defs>
      <circle cx="60" cy="62" r="32" fill="none" stroke="#FFD700" strokeWidth="1.5" opacity="0.6"/>
      <circle cx="60" cy="62" r="26" fill="none" stroke="#FFD700" strokeWidth="1.5" opacity="0.7"/>
      <circle cx="60" cy="33" r="8" fill={`url(#blueGrad-${size})`}/>
      <circle cx="34" cy="78" r="8" fill={`url(#redGrad-${size})`}/>
      <circle cx="86" cy="78" r="8" fill={`url(#greenGrad-${size})`}/>
      <text
        x="60"
        y="67"
        fontFamily="'Helvetica Neue', 'Arial', sans-serif"
        fontSize="16"
        fontWeight="700"
        fill="#2C3E50"
        textAnchor="middle"
        letterSpacing="1.5"
      >
        FHO
      </text>
    </svg>
  );

  return (
    <div style={{
      minHeight: '100vh',
      background: '#5b9bd5',
      fontFamily: "'Georgia', 'Times New Roman', serif",
      color: '#1e3a5f',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Soft light orb - top center */}
      <div style={{
        position: 'absolute',
        top: '-5%',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '80%',
        height: '55%',
        background: 'radial-gradient(ellipse at center, rgba(79, 70, 229, 0.08) 0%, rgba(79, 70, 229, 0.03) 40%, transparent 70%)',
        pointerEvents: 'none',
        zIndex: 0
      }} />

      {/* Animated background orbs */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(79, 70, 229, 0.07) 0%, transparent 70%)',
        borderRadius: '50%',
        filter: 'blur(60px)',
        animation: 'float 8s ease-in-out infinite',
        zIndex: 0
      }} />
      <div style={{
        position: 'absolute',
        bottom: '10%',
        right: '5%',
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(5, 150, 105, 0.07) 0%, transparent 70%)',
        borderRadius: '50%',
        filter: 'blur(60px)',
        animation: 'float 10s ease-in-out infinite',
        zIndex: 0
      }} />
      <div style={{
        position: 'absolute',
        top: '40%',
        right: '10%',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(30, 58, 95, 0.05) 0%, transparent 60%)',
        borderRadius: '50%',
        filter: 'blur(50px)',
        animation: 'float 12s ease-in-out infinite reverse',
        zIndex: 0
      }} />

      {/* Sticky Header */}
      <header style={{
        padding: '20px 5%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'rgba(240, 244, 248, 0.85)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(30, 58, 95, 0.1)',
        boxShadow: '0 1px 12px rgba(30, 58, 95, 0.06)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}>
        <div
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            cursor: 'pointer'
          }}
        >
          <FHOLogo size={50} />
          <div style={{
            fontSize: '28px',
            fontWeight: '800',
            letterSpacing: '1px',
            color: '#1e3a5f'
          }}>
            EMIT
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <button
            onClick={() => navigate('/why')}
            style={{
              padding: window.innerWidth < 768 ? '8px 16px' : '10px 24px',
              background: 'transparent',
              border: '2px solid rgba(30, 58, 95, 0.3)',
              borderRadius: '24px',
              color: '#1e3a5f',
              fontWeight: '600',
              fontSize: window.innerWidth < 768 ? '13px' : '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(30, 58, 95, 0.06)';
              e.target.style.borderColor = '#1e3a5f';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.borderColor = 'rgba(30, 58, 95, 0.3)';
            }}
          >
            Why Emit?
          </button>

          <button
            onClick={() => navigate('/login')}
            style={{
              padding: window.innerWidth < 768 ? '8px 20px' : '10px 28px',
              background: 'linear-gradient(135deg, #4f46e5, #3730a3)',
              border: 'none',
              borderRadius: '24px',
              color: 'white',
              fontWeight: '600',
              fontSize: window.innerWidth < 768 ? '13px' : '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 16px rgba(79, 70, 229, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 24px rgba(79, 70, 229, 0.4)';
              e.target.style.background = 'linear-gradient(135deg, #6366f1, #4f46e5)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 16px rgba(79, 70, 229, 0.3)';
              e.target.style.background = 'linear-gradient(135deg, #4f46e5, #3730a3)';
            }}
          >
            Login
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{
        padding: '120px 5% 80px',
        textAlign: 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Powered By Badge */}
        <div style={{ marginBottom: '32px' }}>
          <span style={{
            fontSize: '12px',
            color: '#059669',
            fontWeight: '600',
            fontStyle: 'italic',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            display: 'inline-block'
          }}>
            Powered by
          </span>
        </div>

        {/* FHO Logo */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '40px'
        }}>
          <FHOLogo size={140} />
        </div>

        {/* Main Headline */}
        <h1 style={{
          fontSize: 'clamp(48px, 8vw, 72px)',
          fontWeight: '800',
          marginBottom: '24px',
          lineHeight: '1.1',
          color: '#1e3a5f'
        }}>
          Don't Just Read the Bible
        </h1>

        <h2 style={{
          fontSize: 'clamp(36px, 6vw, 56px)',
          fontWeight: '700',
          marginBottom: '32px',
          lineHeight: '1.2',
          background: 'linear-gradient(135deg, #4f46e5, #059669)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          <strong>Emit</strong> the Bible
        </h2>

        <p style={{
          fontSize: 'clamp(20px, 3vw, 28px)',
          fontWeight: '300',
          marginBottom: '48px',
          lineHeight: '1.6',
          color: '#374151',
          maxWidth: '800px',
          margin: '0 auto 48px'
        }}>
          Become the Living Word. Transform scripture into living wisdom through the FHO transformation system.
        </p>
        <div style={{ marginBottom: '40px' }}>
          <SuperPhilosophyTagline variant="consumer" />
        </div>

        {/* CTA Buttons */}
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/signup')}
            style={{
              padding: '18px 48px',
              fontSize: '18px',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #4f46e5, #3730a3)',
              color: 'white',
              border: 'none',
              borderRadius: '28px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 28px rgba(79, 70, 229, 0.35)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = '0 12px 36px rgba(79, 70, 229, 0.45)';
              e.target.style.background = 'linear-gradient(135deg, #6366f1, #4f46e5)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 28px rgba(79, 70, 229, 0.35)';
              e.target.style.background = 'linear-gradient(135deg, #4f46e5, #3730a3)';
            }}
          >
            Start Your Journey
          </button>

          <button
            onClick={() => navigate('/platform')}
            style={{
              padding: '18px 48px',
              fontSize: '18px',
              fontWeight: '600',
              background: 'white',
              color: '#1e3a5f',
              border: '2px solid rgba(30, 58, 95, 0.2)',
              borderRadius: '28px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 16px rgba(30, 58, 95, 0.08)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#f8fafc';
              e.target.style.borderColor = 'rgba(79, 70, 229, 0.4)';
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = '0 8px 24px rgba(30, 58, 95, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'white';
              e.target.style.borderColor = 'rgba(30, 58, 95, 0.2)';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 16px rgba(30, 58, 95, 0.08)';
            }}
          >
            Explore Platform
          </button>
        </div>
      </section>

      {/* Features Section */}
      <section style={{
        padding: '80px 5%',
        position: 'relative',
        zIndex: 1
      }}>
        <h2 style={{
          fontSize: 'clamp(36px, 5vw, 48px)',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '64px',
          color: '#1e3a5f'
        }}>
          Your Transformation Tools
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '28px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {[
            {
              icon: '📖',
              title: 'Living Scripture',
              desc: 'Transform verses into actionable wisdom'
            },
            {
              icon: '⚡',
              title: 'Real-time Flow',
              desc: 'Apply biblical truth to your actual life'
            },
            {
              icon: '📊',
              title: 'Daily Practice',
              desc: 'Log sessions, build streaks, see real growth'
            }
          ].map((feature, idx) => (
            <div key={idx} style={{
              padding: '32px 24px',
              background: 'white',
              borderRadius: '20px',
              border: '1px solid rgba(30, 58, 95, 0.08)',
              boxShadow: '0 4px 16px rgba(30, 58, 95, 0.06)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = 'rgba(79, 70, 229, 0.3)';
              e.currentTarget.style.boxShadow = '0 16px 40px rgba(79, 70, 229, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(30, 58, 95, 0.08)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(30, 58, 95, 0.06)';
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>{feature.icon}</div>
              <h3 style={{
                fontSize: '22px',
                fontWeight: '700',
                marginBottom: '12px',
                color: '#1e3a5f'
              }}>
                {feature.title}
              </h3>
              <p style={{
                fontSize: '15px',
                lineHeight: '1.6',
                color: '#6b7280',
                margin: 0
              }}>
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Transformation Statement */}
      <section style={{
        padding: '80px 5%',
        background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(5, 150, 105, 0.04) 100%)',
        borderTop: '1px solid rgba(30, 58, 95, 0.08)',
        borderBottom: '1px solid rgba(30, 58, 95, 0.08)',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(32px, 5vw, 48px)',
            fontWeight: '700',
            marginBottom: '24px',
            color: '#1e3a5f'
          }}>
            The First Operating System for Human Transformation
          </h2>
          <p style={{
            fontSize: 'clamp(18px, 2.5vw, 24px)',
            lineHeight: '1.8',
            color: '#374151',
            marginBottom: '40px'
          }}>
            Most Bible apps help you <em>read</em> scripture.<br/>
            Emit helps you <strong style={{ color: '#1e3a5f' }}>become</strong> scripture.
          </p>

          {/* Matthew 13:52 Quote */}
          <div style={{
            padding: '40px',
            background: 'white',
            borderRadius: '20px',
            border: '2px solid rgba(79, 70, 229, 0.15)',
            boxShadow: '0 8px 32px rgba(79, 70, 229, 0.08)',
            marginBottom: '40px',
            maxWidth: '800px',
            margin: '0 auto 40px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>📖</div>
            <p style={{
              fontSize: 'clamp(16px, 2vw, 20px)',
              fontStyle: 'italic',
              lineHeight: '1.8',
              color: '#374151',
              marginBottom: '16px'
            }}>
              "Therefore every scribe who has been trained for the kingdom of heaven is like a master
              of a house, who brings out of his treasure what is new and what is old."
            </p>
            <p style={{
              fontSize: '16px',
              color: '#4f46e5',
              fontWeight: '600',
              marginBottom: '24px'
            }}>
              — Matthew 13:52
            </p>
            <p style={{
              fontSize: 'clamp(14px, 1.8vw, 18px)',
              lineHeight: '1.7',
              color: '#6b7280',
              textAlign: 'left',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              You're not just storing information — you're synthesizing ancient wisdom with new understanding
              to create transformation. Emit positions you as that trained scribe, skillfully combining
              timeless truth with innovative systems that meet you where you are in this digital age.
            </p>
          </div>

          <button
            onClick={() => {
              navigate('/why');
              window.scrollTo(0, 0);
            }}
            style={{
              padding: '16px 40px',
              fontSize: '18px',
              fontWeight: '600',
              background: '#1e3a5f',
              color: 'white',
              border: 'none',
              borderRadius: '24px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 20px rgba(30, 58, 95, 0.25)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 28px rgba(30, 58, 95, 0.35)';
              e.target.style.background = '#2a4f7a';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 20px rgba(30, 58, 95, 0.25)';
              e.target.style.background = '#1e3a5f';
            }}
          >
            See How We're Different →
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '60px 5% 40px',
        textAlign: 'center',
        borderTop: '1px solid rgba(30, 58, 95, 0.1)',
        background: 'white',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ marginBottom: '32px' }}>
          <FHOLogo size={60} />
        </div>
        <div style={{
          display: 'flex',
          gap: '32px',
          justifyContent: 'center',
          flexWrap: 'wrap',
          marginBottom: '24px'
        }}>
          {[
            { label: 'Platform', path: '/platform' },
            { label: 'Why Emit?', path: '/why' },
            { label: 'Login', path: '/login' }
          ].map(({ label, path }) => (
            <button
              key={label}
              onClick={() => { navigate(path); window.scrollTo(0, 0); }}
              style={{
                background: 'none',
                border: 'none',
                color: '#6b7280',
                fontSize: '15px',
                cursor: 'pointer',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#1e3a5f'}
              onMouseLeave={(e) => e.target.style.color = '#6b7280'}
            >
              {label}
            </button>
          ))}
        </div>
        <p style={{
          fontSize: '14px',
          color: '#9ca3af',
          margin: 0
        }}>
          2025 Emit. Powered by FHO. All rights reserved.
        </p>
      </footer>

      {/* CSS Animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          33% { transform: translateY(-30px) translateX(20px); }
          66% { transform: translateY(-10px) translateX(-20px); }
        }
      `}</style>
    </div>
  );
};

export default HeroPage;
